/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import { createGlobalStyle } from 'styled-components';

/**
 * Estilização do componente ChangeCursor
 */
export const ChangeCursor = createGlobalStyle`
  #map, .leaflet-interactive {
    cursor: url(${({ cursor }) => cursor}) 13 28, auto;
  }

  //aplicar o cursor customizado nos tooltips dos rótulos
  .leaflet-tooltip.leaflet-clickable {
    cursor: url(${({ cursor }) => cursor}) 13 28, auto;
  }
`;
